import React from "react";
import About from "./pages/about";
import Section from "./pages/section";
import History from "./pages/history";
import WhosWho from "./pages/whoswho";
import Contact from "./pages/contact";

import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { HashLink as Link } from "react-router-hash-link"; 

import styles from "./styles/App.module.css";

function App() {
  return (
    <Router>
      <nav className={styles.navBar}>
        <ul>
          <li><Link to="/#about">About</Link></li>
          <li><Link to="/squirrels">Squirrels</Link></li>
          <li><Link to="/beavers">Beavers</Link></li>
          <li><Link to="/cubs">Cubs</Link></li>
          <li><Link to="/scouts">Scouts</Link></li>
          <li><Link to="/whoswho#leaders">Who's Who</Link></li>
          <li><Link to="/history">History</Link></li>
          <li><Link to="/contact">Contact</Link></li>
        </ul>
      </nav>

      <Routes>
        <Route path="/" element={<About />} />
        <Route path="/squirrels" element={<Section section="squirrels" />} />
        <Route path="/beavers" element={<Section section="beavers" />} />
        <Route path="/cubs" element={<Section section="cubs" />} />
        <Route path="/scouts" element={<Section section="scouts" />} />
        <Route path="/whoswho" element={<WhosWho />} />
        <Route path="/history" element={<History />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  );
}

export default App;
